const CHAMBER_INSTRUCTION_LINKS: Record<string, string> = {
  "Manage Chamber Profile.pdf": "https://canva.link/2b3lu6soiwkebay",
  "Update Existing Member.pdf": "https://canva.link/zned70hyrtukpbe",
  "Manage Member Perks.pdf": "https://canva.link/pohds4rejonnfx2",
  "Create Member Perks.pdf": "https://canva.link/5dpv470lhlmrmq0",
  "View Active Reward Campaign.pdf": "https://canva.link/a2yai7qdfcpacxr",
  "Update Rewards Contest.pdf": "https://canva.link/28nltmic4gwy4k1",
  "View Previous Rewards.pdf": "https://canva.link/rs2tnsw2gur814b",
  "Create Rewards Contest.pdf": "https://canva.link/m2jgmc3l9djjhxd",
  "PerkLinks.pdf": "https://canva.link/ngasfn50dspm8i2",
  "Update Member Perks.pdf": "https://canva.link/sn067qoif4m167h",
  "Manage Members.pdf": "https://canva.link/rus2yhg3jwui360",
  "Create New Member.pdf": "https://canva.link/n6m0jpbefpw517c",
  "Manage Category Member Advertising Activations.pdf":
    "https://canva.link/4zf9i6rufz7lmzd",
  "Activate Category Member Advertising Banner.pdf":
    "https://canva.link/oge3wbwk04lpm1m",
  "Add and manage member Feature Member Banners.pdf":
    "https://canva.link/xetauxhq94tysnf",
  "Manage Featured Member Banner Activation.pdf":
    "https://canva.link/lutvqspeuo0zxoh",
  "Activate Featured Member Profile & Perks Banners.pdf":
    "https://canva.link/wc8fayfa9wd1iic",
  "Instruction on Sending Member Credentials":
    "https://canva.link/ixy6ppq9kx3ng1w",
};

const MEMBER_INSTRUCTION_LINKS: Record<string, string> = {
  "Member Dashboard - Create a Perk.pdf": "https://canva.link/nb2vxm18dr1mabv",
  "Member Dashboard -  Manage Company Profile.pdf":
    "https://canva.link/fz7n0fqxfbntnki",
  "Member Dashboard - Category Banners  ACTIVE.pdf":
    "https://canva.link/fd4wbeoijtp21e0",
  "Member Dashboard - Category Banners  INACTIVE.pdf":
    "https://canva.link/lm1do26c18yw6yg",
  "Member Dashboard - Update Perk.pdf": "https://canva.link/l8kw4a2e59s0byc",
  "Member Dashboard - Manage Company Perks.pdf":
    "https://canva.link/2ozz1xv59pj26zt",
};

export const openInstructionPdf = (key: string): void => {
  const url = CHAMBER_INSTRUCTION_LINKS[key];
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const openMemberInstructionPdf = (key: string): void => {
  const url = MEMBER_INSTRUCTION_LINKS[key];
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
